import { round } from 'lodash';
import { BlockNoteEditor } from '@blocknote/core';
import { BlockSchema } from '../schema';
import { applyImageBlockPreviewWidthFromNaturalDimensions } from './apply-image-block-preview-dimensions';
import { commentaryEditorMaxPreviewWidthCssPx } from './commentary-image-layout';
import getEditorDomSearchRoot from './get-editor-dom-search-root';
import readImageFileDimensionsCssPxFromFile from './read-image-file-dimensions-css-px-from-file';

export default function scheduleSetImagePreviewDimensionsAfterUpload(
  editor: BlockNoteEditor<BlockSchema>,
  blockId: string | undefined,
  file: File,
) {
  if (!blockId) {
    return;
  }

  const run = async () => {
    const dimensions = await readImageFileDimensionsCssPxFromFile(file);
    if (!dimensions) {
      return;
    }
    const editorRoot = getEditorDomSearchRoot(editor);
    const maxWidthCssPx = editorRoot
      ? measureCommentaryEditorContentWidthCssPx(editorRoot)
      : commentaryEditorMaxPreviewWidthCssPx;
    applyImageBlockPreviewWidthFromNaturalDimensions(
      editor,
      blockId,
      dimensions,
      maxWidthCssPx,
    );
  };

  const scheduleRun = () => {
    setTimeout(() => {
      void run();
    }, 0);
  };

  if (editor.domElement) {
    scheduleRun();
    return;
  }

  editor.onMount(scheduleRun);
}

function measureCommentaryEditorContentWidthCssPx(editorRoot: HTMLElement) {
  const width = editorRoot.clientWidth;
  if (width <= 0) {
    return commentaryEditorMaxPreviewWidthCssPx;
  }
  return round(width);
}
